import React, { useEffect, useRef } from 'react';
import { motion, useMotionValue, useTransform, animate, useInView } from 'framer-motion';

// Optimized Counter Component
const Counter = ({ from, to }) => {
    const count = useMotionValue(from);
    const rounded = useTransform(count, (latest) => Math.round(latest));
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true }); // Sirf jab view mein aaye tabhi chale

    useEffect(() => {
        if (isInView) {
            const controls = animate(count, to, { duration: 2, ease: "easeOut" });
            return controls.stop;
        }
    }, [isInView, count, to]);

    return <motion.span ref={ref}>{rounded}</motion.span>;
};

const Stats = () => {
    const stats = [
        { number: 21, label: 'Years of Excellence', icon: '📈' },
        { number: 100, label: 'Success Rate', icon: '🎯' },
        { number: 2563, label: 'Satisfied Clients', icon: '👥' },
        { number: 8, label: 'Services', icon: '📋' },
    ];

    return (
        <section className="relative py-24 bg-cover bg-center bg-fixed" style={{ backgroundImage: "url('/runway-bg.jpg')" }}>
            <div className="absolute inset-0 bg-black/50"></div>

            <div className="relative max-w-7xl mx-auto px-6 text-center text-white">
                <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} className="uppercase tracking-[0.3em] text-sm mb-2 opacity-80">
                    Trusted Since 2005
                </motion.p>
                <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }} className="text-5xl font-bold mb-16">
                    SCALING SUCCESS
                </motion.h2>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-12">
                    {stats.map((item, index) => (
                        <div key={index} className="flex flex-col items-center">
                            <div className="text-4xl mb-4 border border-white/30 p-6 rounded-full hover:bg-white/10 transition-all duration-300">
                                {item.icon}
                            </div>
                            <h3 className="text-5xl font-extrabold mb-2 text-[#f15a24]">
                                <Counter from={0} to={item.number} />
                                {index === 1 ? "%" : "+"}
                            </h3>
                            <p className="text-sm uppercase tracking-widest font-bold">{item.label}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Stats;